const renderAll = async () => {
    root.innerHTML = `
        <style>
            .wccp-nav-buttons {
                display: flex;
                gap: 10px;
                margin: 20px 0;
            }
            .wccp-nav-buttons button {
                padding: 8px 16px;
                border: 1px solid #ddd;
                background: #fff;
                cursor: pointer;
            }
            .wccp-nav-buttons button:disabled {
                opacity: 0.5;
                cursor: not-allowed;
            }
        </style>
    `;
    const frag = document.createDocumentFragment();
    (STATE.data.components || []).forEach((c, idx) => frag.appendChild(renderStep(c, idx)));
    root.appendChild(frag);
    bindStepClicks();
    await applyDefaults();
    qsa(selFor(CLASSES.step), root).forEach(step => {
        if (step.style.display !== 'none') ensureVariationsForStep(step);
    });
    (function appendATCOnLastStep() {
        const steps = qsa(selFor(CLASSES.step), root);
        if (!steps.length) return;

        const lastStep = steps[steps.length - 1];
        const nav = lastStep.querySelector('.wccp-nav-buttons') || lastStep;

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'button button-primary wccp-atc-btn wccp-atc-btn-none';
        btn.textContent = 'COMPLETE AND GET PRICE';

        btn.addEventListener('click', async () => {
            const compId = Number(lastStep.dataset.item_id);
            const selectedPid = STATE.selected[compId];
            const needsVariation = !!qs(`${selFor(CLASSES.option)}[data-product-id="${selectedPid}"] .wccp-variation-select`, lastStep);
            if (needsVariation && !STATE.selectedVariants[compId]) {
                const sel = qs(`${selFor(CLASSES.option)}[data-product-id="${selectedPid}"] .wccp-variation-select`, lastStep);
                if (sel) sel.focus();
                alert('Please choose a variation before adding to cart.');
                return;
            }

            await addCompositeToCart();
        });

        const style = document.createElement('style');
        style.textContent = `
.wccp-atc-btn { margin-left: auto; }
.wccp-atc-btn-none { display: none;}
.wccp-nav-buttons { align-items: center; }
`;
        document.head.appendChild(style);
`
.wccp-nav-buttons { align-items: center; }
`;
        document.head.appendChild(style);

        // nav.appendChild(btn);
    })();

};